<template>
    <div
        class="loader-container"
        v-show="isLoading"
    >
        <div class="loader-backdrop" />
        <div class="loader center-align">
            <div class="bar-container">
                <div class="bar" />
            </div>
            <div
                class="text-center"
                :key="updateKey"
            >
                <h3> {{ $t('SpinnerLoadMessage.title') }} </h3>
                <p v-show="longLoading">
                    {{ $t('SpinnerLoadMessage.subTitle') }}
                </p>
            </div>
        </div>
    </div>
</template>

<script lang="ts">

import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class Loader extends Vue {
    longLoading = false;
    updateKey = 0;
    timeoutMs = 10000;
    timeoutRef: any = null;

    constructor() {
        super();
    }

    get isLoading(): boolean {
        return this.$store.getters.isLoading;
    }

    @Watch('isLoading')
    onShowLoading(newVal: boolean, _: boolean): void {
        if (newVal) {
            this.timeoutRef = setTimeout(() => {
                this.longLoading = true
                this.updateKey += 1;
            }, this.timeoutMs)
        } else {
            this.longLoading = false;
            clearTimeout(this.timeoutRef);
        }
    }
}

</script>
<style scoped lang="less">
@import '../../variables.less';

.loader-container {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    z-index: 999999;
    .loader-backdrop {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        background: #000;
        opacity: 0.5;
        z-index: 999998;
    }
    .loader {
        width: 30%;
        height: 30%;
        max-height: 100px;
        max-width: 340px;
        z-index: 999999;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        margin: auto;
        border-radius: 3px;
        h3 {
            color: #fff;
        }
        .bar-container {
            width: 80%;
            margin: auto;
            .bar {
                width: 5rem;
                height: 5rem;
                clear: both;
                margin: 0 auto;
                border: 8px rgba(0,167,245,0.15) solid;
                border-top: 8px #00a7f5 solid;
                border-left: 8px #00a7f5 solid;
                border-radius: 50%;
                animation: spin 0.8s linear infinite;
            }
        }
        .text-center {
            text-align: center;
            color: #fff;
            margin-top: 10px;
        }
    }

    @keyframes left-to-right {
        0% { margin-left: -33% }
        100% { margin-left: 133% }
    }

    @keyframes spin {
    from {
        transform:rotate(0deg);
    }
    to {
        transform:rotate(360deg);
    }
}
}
</style>
